import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import LevelSelect from './pages/LevelSelect';
import Game from './pages/Game';
import { getCookie } from './utils/cookies'; 

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const playerName = getCookie('playerName');
  const playerPhone = getCookie('playerPhone');
  if (!playerName || !playerPhone) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        
        <Route
          path="/levels"
          element={
            <ProtectedRoute>
              <LevelSelect />
            </ProtectedRoute>
            
          }
        />

        {/* Protected Game Route */}
        <Route
          path="/game/:level"
          element={
            <ProtectedRoute>
              <Game />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;